<template>
  <b-modal
    id="modal-search-box"
    :no-close-on-backdrop="true"
    :no-close-on-esc="false"
    :title="$t('Search Box')"
    :ok-title="$t('OK')"
    :cancel-title="$t('Cancel')"
    cancel-variant="outline-secondary"
    @ok="handleOk"
  >
    <form-search-box
      ref="box_search_form"
      v-model="box"
      @submit="submitted"
    />
  </b-modal>
</template>

<script>
import {
  BModal, VBModal,
} from 'bootstrap-vue'

import FormSearchBox from '@/layouts/components/forms/FormSearchBox.vue'

export default {
  components: {
    BModal,
    FormSearchBox,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    box: {
      type: Object,
      default: null,
    },
  },
  methods: {
    submitted(searchObj) {
      this.$emit('submit', searchObj)
      this.$bvModal.hide('modal-search-box')
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.$refs.box_search_form.validationForm()
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
.vs__dropdown-toggle {
  border:1px solid #d8d6de !important
}
</style>
